import axios from 'axios';

export const getAllCustomerRegistrations = async () => {
    let config = {
        headers: { 'Accept': 'application/json' },
        params: { "db": "iwash_laundry" }
    }
    //  const url = "http://localhost/iwash-php/api/allCustomerRegistrations.php";
    // const url = "https://testmembership.bktsystems.com/api/UAT_allCustomerRegistrations.php";
    const url = "https://testmembership.bktsystems.com/api/allCustomerRegistrations.php";
    const response = await axios.get(url, config);
    return response.data;
}

export const getCustomerOrders = async (customerid) => {
    let config = {
        headers: { 'Accept': 'application/json' },
        params: { "db": "iwash_laundry", "customerid": customerid }
    }
    //  const url = "http://localhost/iwash-php/api/getCustomerOrders.php";
    // const url = "https://testmembership.bktsystems.com/api/UAT_getCustomerOrders.php";
    const url = "https://testmembership.bktsystems.com/api/getCustomerOrders.php";
    const response = await axios.get(url, config);
    return response.data;
}

export const getAllCustomerOrders = async () => {
    let config = {
        headers: { 'Accept': 'application/json' },
        params: { "db": "iwash_laundry" }
    }
    // const url = "http://localhost/iwash-php/api/getAllCustomerOrders.php";
    //const url = "https://testmembership.bktsystems.com/api/UAT_getAllCustomerOrders.php";
    const url = "https://testmembership.bktsystems.com/api/getAllCustomerOrders.php";
    const response = await axios.get(url, config);
    return response.data;
}

export const getOrderDetails = async (orderid) => {
    let config = {
        headers: { 'Accept': 'application/json' },
        params: { "db": "iwash_laundry", "orderid": orderid }
    }
   // const url = "http://localhost/iwash-php/api/getOrderDetails.php";
    // const url = "https://testmembership.bktsystems.com/api/UAT_getOrderDetails.php";
    const url = "https://testmembership.bktsystems.com/api/getOrderDetails.php";
    const response = await axios.get(url, config);
    // console.log("Order details response: ", response.data);
    return response.data;
}

export const getOrderStatuses = async (orderid) => {
    let config = {
        headers: { 'Accept': 'application/json' },
        params: { "db": "iwash_laundry", "orderid": orderid }
    }
   // const url = "http://localhost/iwash-php/api/getOrderStatuses.php";
    // const url = "https://testmembership.bktsystems.com/api/UAT_getOrderStatuses.php";
    const url = "https://testmembership.bktsystems.com/api/getOrderStatuses.php";
    const response = await axios.get(url, config);
    //  console.log("Order details response: ", response.data);
    return response.data;
}

export const getAllOrderStatuses = async () => {
    let config = {
        headers: { 'Accept': 'application/json' },
        params: { "db": "iwash_laundry" }
    }
   // const url = "http://localhost/iwash-php/api/getAllOrderStatuses.php";
    // const url = "https://testmembership.bktsystems.com/api/UAT_getAllOrderStatuses.php";
    const url = "https://testmembership.bktsystems.com/api/getAllOrderStatuses.php";
    const response = await axios.get(url, config);
    //  console.log("Order details response: ", response.data);
    return response.data;
}
export const generateToken = () => {
    return Math.random().toString(36).substr(2) + Math.random().toString(36).substr(2);
};

export const isLoggedIn = () => {
    // console.log("Token in localStorage: ", localStorage.getItem("token"));
    return localStorage.getItem("token");
};

export const AppLogout = () => {
    localStorage.removeItem("token");
    this.props.navigate('/', {
        state: {
        }
    });
}

export const formatDate = (date) => {
    const today = new Date();
    const yesterday = new Date();

    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
        return 'Today';
    } else if (date.toDateString() === yesterday.toDateString()) {
        return 'Yesterday';
    } else {
        // Return standard format if neither
        return date.toLocaleDateString('en-UK', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    }
};